import { render, staticRenderFns } from "./ALaCarteModules.vue?vue&type=template&id=77d8b8af&"
import script from "./ALaCarteModules.vue?vue&type=script&lang=ts&"
export * from "./ALaCarteModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {GCardIcon,VCard,VCardTitle,VDivider})
